<template>
    <div class="popover-legend-container">
        <div class="popover-legend-color" :style="{background: item.color}"></div>
        <div class="popover-legend-name">{{item.name}}: </div>
        <div class="popover-legend-value">{{item.num}}</div>
    </div>
</template>

<script>
export default {
    props: {
        item: Object
    }
}
</script>

<style lang="less" scoped>
.popover-legend-container {
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;

    .popover-legend-color {
        width: 16rem;
        height: 16rem;
    }

    .popover-legend-name, .popover-legend-value {
        font-size: 18rem;
        font-weight: 500;
        color: #666666;

        margin-left: 5rem;
    }
}
</style>